const files = [
  {
    id: 0,
    name: 'ПРИЛОЖЕНИЕ 8.6 Баланс 2016г',
    file: 'ПРИЛОЖЕНИЕ 8.6 Баланс 2016г.xlsx',
  },
  {
    id: 1,
    name: 'ПРИЛОЖЕНИЕ 8.7 Баланс 2017г',
    file: 'ПРИЛОЖЕНИЕ 8.7 Баланс 2017г.xlsx',
  },
  {
    id: 2,
    name: 'ПРИЛОЖЕНИЕ 8.8 Баланс 2018г',
    file: 'ПРИЛОЖЕНИЕ 8.8 Баланс 2018г.xlsx',
  },
  {
    id: 3,
    name: 'ПРИЛОЖЕНИЕ 8.9 Баланс 2019г',
    file: 'ПРИЛОЖЕНИЕ 8.9 Баланс 2019г.xlsx',
  },
  {
    id: 4,
    name: 'ПРИЛОЖЕНИЕ 8.10 Баланс 2020г.',
    file: 'ПРИЛОЖЕНИЕ 8.10 Баланс 2020г.xlsx',
  },
  {
    id: 5,
    name: 'ПРИЛОЖЕНИЕ 8.16 Баланс ТКО 2016г',
    file: 'ПРИЛОЖЕНИЕ 8.16 Баланс ТКО 2016г.xlsx',
  },
  {
    id: 6,
    name: 'ПРИЛОЖЕНИЕ 8.17 Баланс ТКО 2017г',
    file: 'ПРИЛОЖЕНИЕ 8.17 Баланс ТКО 2017г.xlsx',
  },
  {
    id: 7,
    name: 'ПРИЛОЖЕНИЕ 8.18 Баланс ТКО 2018г',
    file: 'ПРИЛОЖЕНИЕ 8.18 Баланс ТКО 2018г.xlsx',
  },
  {
    id: 8,
    name: 'ПРИЛОЖЕНИЕ 8.19 Баланс ТКО 2019г',
    file: 'ПРИЛОЖЕНИЕ 8.19 Баланс ТКО 2019г.xlsx',
  },
  {
    id: 9,
    name: 'ПРИЛОЖЕНИЕ 8.20 Баланс ТКО 2020г',
    file: 'ПРИЛОЖЕНИЕ 8.20 Баланс ТКО 2020г.xlsx',
  },
  {
    id: 10,
    name: 'ПРИЛОЖЕНИЕ 8.23 Баланс 2021г',
    file: 'ПРИЛОЖЕНИЕ 8.23 Баланс 2021г.xlsx',
  },
  {
    id: 11,
    name: 'ПРИЛОЖЕНИЕ 8.24 Баланс 2022г',
    file: 'ПРИЛОЖЕНИЕ 8.24 Баланс 2022г.xlsx',
  },
  {
    id: 12,
    name: 'ПРИЛОЖЕНИЕ 8.27 Баланс ТКО 2021г',
    file: 'ПРИЛОЖЕНИЕ 8.27 Баланс ТКО 2021г.xlsx',
  },
  {
    id: 13,
    name: 'ПРИЛОЖЕНИЕ 8.28 Баланс ТКО 2022г',
    file: 'ПРИЛОЖЕНИЕ 8.28 Баланс ТКО 2022г.xlsx',
  },
  {
    id: 14,
    name: 'ПРИЛОЖЕНИЕ 8.1 Исходные данные 2016г',
    file: 'ПРИЛОЖЕНИЕ_8_1_Исходные_данные_2016г.xlsx',
  },
  {
    id: 15,
    name: 'ПРИЛОЖЕНИЕ 8.2 Исходные данные 2017г',
    file: 'ПРИЛОЖЕНИЕ_8_2_Исходные_данные_2017г.xlsx',
  },
  {
    id: 16,
    name: 'ПРИЛОЖЕНИЕ 8.3 Исходные данные 2018г',
    file: 'ПРИЛОЖЕНИЕ_8_3_Исходные_данные_2018г.xlsx',
  },
  {
    id: 17,
    name: 'ПРИЛОЖЕНИЕ 8.4 Исходные данные 2019г',
    file: 'ПРИЛОЖЕНИЕ_8_4_Исходные_данные_2019г.xlsx',
  },
  {
    id: 18,
    name: 'ПРИЛОЖЕНИЕ 8.5 Исходные данные 2020г',
    file: 'ПРИЛОЖЕНИЕ_8_5_Исходные_данные_2020г.xlsx',
  },
  {
    id: 19,
    name: 'ПРИЛОЖЕНИЕ 8.11 Баланс коммунальных отходов 2016г',
    file: 'ПРИЛОЖЕНИЕ_8_11_Баланс_коммунальных_отходов_2016г.xlsx',
  },
  {
    id: 20,
    name: 'ПРИЛОЖЕНИЕ 8.12 Баланс коммунальных отходов 2017г',
    file: 'ПРИЛОЖЕНИЕ_8_12_Баланс_коммунальных_отходов_2017г.xlsx',
  },
  {
    id: 21,
    name: 'ПРИЛОЖЕНИЕ 8.13 Баланс коммунальных отходов 2018г',
    file: 'ПРИЛОЖЕНИЕ_8_13_Баланс_коммунальных_отходов_2018г.xlsx',
  },
  {
    id: 22,
    name: 'ПРИЛОЖЕНИЕ 8.14 Баланс коммунальных отходов 2019г',
    file: 'ПРИЛОЖЕНИЕ_8_14_Баланс_коммунальных_отходов_2019г.xlsx',
  },
  {
    id: 23,
    name: 'ПРИЛОЖЕНИЕ 8.15 Баланс коммунальных отходов 2020г',
    file: 'ПРИЛОЖЕНИЕ_8_15_Баланс_коммунальных_отходов_2020г.xlsx',
  },
  {
    id: 24,
    name: 'ПРИЛОЖЕНИЕ 8.21 Исходные данные 2021г',
    file: 'ПРИЛОЖЕНИЕ_8_21_Исходные_данные_2021г.xlsx',
  },
  {
    id: 25,
    name: 'ПРИЛОЖЕНИЕ 8.22 Исходные данные 2022г',
    file: 'ПРИЛОЖЕНИЕ_8_22_Исходные_данные_2022г.xlsx',
  },
  {
    id: 26,
    name: 'ПРИЛОЖЕНИЕ 8.25 Исходные данные по ТКО 2021г',
    file: 'ПРИЛОЖЕНИЕ_8_25_Исходные_данные_по_ТКО_2021г.xlsx',
  },
  {
    id: 27,
    name: 'ПРИЛОЖЕНИЕ 8.26 Исходные данные по ТКО 2022г',
    file: 'ПРИЛОЖЕНИЕ_8_26_Исходные_данные_по_ТКО_2022г.xlsx',
  },
  {
    id: 28,
    name: 'Раздел 8 Баланс количественных характеристик',
    file: 'Раздел_8_Баланс_количественных_характеристик.docx',
  },
]

export default files
